import {call, put, takeLatest} from 'redux-saga/effects';
import oauthActions from '../actions/oauth.actions';
import OAuthApi from '../api/OAuthApi';
import errorActions from '../actions/error.actions';

function* getOAuth(action) {
    try {
        const data = yield call(OAuthApi.getOAuth, action.payload);
        yield put(oauthActions.getOAuthSuccess(data));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(oauthActions.getOAuthFailed(e));
    }
}

function* getOAuthLink(action) {
    try {
        const data = yield call(OAuthApi.getOAuthLink, action.payload);
        yield put(oauthActions.getOAuthLinkSuccess(data));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(oauthActions.getOAuthLinkFailed(e));
    }
}

function* oauthSaga() {
    yield takeLatest(oauthActions.TYPES.GET_OAUTH, getOAuth);
    yield takeLatest(oauthActions.TYPES.GET_OAUTH_LINK, getOAuthLink);
}

export default oauthSaga;
